export function insightsChangeColorGet(
  change24hPercent: number | undefined,
): string {
  if (typeof change24hPercent !== "number") {
    return "text-zinc-400";
  }

  if (change24hPercent > 0) {
    return "text-[#65D62B]";
  }

  if (change24hPercent < 0) {
    return "text-[#FF5A00]";
  }

  return "text-zinc-400";
}
